import { ChangeEvent, useEffect } from "react"

import { useQuery } from "react-query"
import { useLocationSearch } from "hooks/useLocationSearch"
import { FilterOption, getMarketsOptions } from "./filters-api"
import { Options } from "components/inputs/Options"
import { useI18n } from "providers/I18n"
import { css } from "@emotion/css"
import { getfilterLabel } from "./utils"

const getDefaultMarket = (
  opts: FilterOption[] | undefined,
): FilterOption | undefined => {
  const malaysia = opts?.find((o) => o.label === "Malaysia (MYS)")
  const first = opts?.[0]
  return malaysia || first
}

export function MarketFilter() {
  const { t } = useI18n()
  const ls = useLocationSearch()
  const { data: markets, updatedAt } = useQuery(
    "reporting/buying-billing/filters/markets",
    getMarketsOptions,
  )

  const firstMarket = getDefaultMarket(markets)
  const marketId = ls.get("marketId", "")!
  useEffect(() => {
    if (Boolean(marketId.trim())) return
    ls.set("marketId", firstMarket?.value || "")
    ls.set("currency", getCurrencyFromMarket(firstMarket?.label))
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [marketId, firstMarket, updatedAt])

  const onMarketChange = (evt: ChangeEvent<HTMLInputElement>) => {
    const { value } = evt?.target
    ls.set("marketId", value ?? "")
    const name = getfilterLabel(value, markets)
    ls.set("currency", getCurrencyFromMarket(name))
  }

  return (
    <Options
      name="market"
      label={t("filters.market")}
      options={markets ?? []}
      value={marketId}
      onChange={onMarketChange}
      className={styles.marginDense}
      inputClass={styles.input}
      margin="none"
      size="small"
      fullWidth={false}
    />
  )
}

function getCurrencyFromMarket(marketName?: string) {
  const countryCodeReg = new RegExp(/\(([^)]+)\)/)
  const matches = countryCodeReg.exec(marketName || "")
  const countryCode = !!matches?.length ? matches[1] : undefined

  let currency

  switch (countryCode) {
    case "IND":
      currency = "INR"
      break
    case "MYS":
      currency = "MYR"
      break
    case "PHL":
      currency = "PHP"
      break
    case "SGP":
      currency = "SGD"
      break
    default:
      currency = "MYR"
      break
  }
  return currency
}

const styles = {
  marginDense: css`
    margin: 0;
    width: 120px;
    > div > div {
      padding-top: var(--spacing-xs);
      padding-bottom: var(--spacing-xs);
    }
  `,
  input: css`
    border: 1px solid var(--disabled-grey);
    padding: revert;
  `,
}
